import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Tabs component
 * @type {Object}
 */
class Tabs extends Component {
    /**
     * Function to render tabs
     * @return {Node} - Tab navigation
     */
    tabsNav() {
        return React.Children.map(this.props.children, (child, index) => {
            const nav = React.cloneElement(child, {
                tabIndex: index,
                isActive: index === this.props.activeTabIndex,
            });

            return nav;
        });
    }

    /**
     * Function to render tab content
     * @return {Node} - Active tab content
     */
    activeTabContent() {
        const { children, activeTabIndex } = this.props;
        let tabContent = '';

        if (children[activeTabIndex]) {
            tabContent = children[activeTabIndex].props.children;
        }

        return tabContent;
    }

    /**
     * React lifecycle
     */
    render() {
        const navClasses = classnames(
            this.props.navClassName,
            'nav-tabs nav-tabs--separated nav-tabs--left ',
        );

        const contentClasses = classnames(this.props.contentClassName, {
            'tabs-content': true,
        });

        return (
            <div>
                <nav className={navClasses}>
                    <div className="nav-tabs__content">{this.tabsNav()}</div>
                </nav>
                <div className={contentClasses}>{this.activeTabContent()}</div>
            </div>
        );
    }
}

Tabs.displayName = 'Tabs';

Tabs.propTypes = {
    activeTabIndex: PropTypes.number,
};

Tabs.defaultProps = {
    activeTabIndex: 0,
};

/**
 * Tabs Functional Component.
 */
export default Tabs;
